import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DISCOUNT_CODE_SUB_CATEGORIES,
  FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES,
  GET_DISCOUNT_CODE_SUB_CATEGORIES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DISCOUNT_CODE_SUB_CATEGORIES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DISCOUNT_CODE_SUB_CATEGORIES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
